import { render } from "./AVALoader.vue?vue&type=template&id=6c4ff7d6&scoped=true"
import script from "./AVALoader.vue?vue&type=script&lang=js"
export * from "./AVALoader.vue?vue&type=script&lang=js"

import "./AVALoader.vue?vue&type=style&index=0&id=6c4ff7d6&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4ff7d6"],['__file',"src/components/GlobalLoader/AVALoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c4ff7d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c4ff7d6', __exports__)) {
    console.log('reload')
    api.reload('6c4ff7d6', __exports__)
  }
  
  module.hot.accept("./AVALoader.vue?vue&type=template&id=6c4ff7d6&scoped=true", () => {
    console.log('re-render')
    api.rerender('6c4ff7d6', render)
  })

}


export default __exports__